import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PHOTOS } from "@/lib/site";
import { trackEvent } from "@/lib/analytics";

const productLines = [
  {
    title: "Acrylic Sheet",
    analyticsName: "Acrylic",
    desc: "Acrylic sheet untuk signage, display, interior, furniture, dekorasi, dan kebutuhan proyek.",
    href: "/produk/animax-acrylic-sheet",
    image: PHOTOS.produkSignage,
    status: "Lihat detail",
  },
  {
    title: "Baja Ringan & Galvalum",
    analyticsName: "Galvalum",
    desc: "Atap galvalum, roofing, baja ringan, aksesoris, dan material pendukung proyek.",
    href: "/produk/baja-ringan-galvalum",
    image: PHOTOS.galvalumWarehouse,
    status: "Lihat detail",
  },
  {
    title: "Kitchen Equipment",
    analyticsName: "Kitchen Equipment",
    desc: "Kategori perlengkapan dapur untuk kebutuhan komersial, operasional, dan proyek hospitality.",
    href: "/produk/kitchen-equipment",
    image: "/images/kitchen-equipment/kitchen-lineup.png",
    status: "Lihat detail",
  },
  {
    title: "Elektronik",
    analyticsName: "Elektronik",
    desc: "Smart TV AMEX untuk hiburan, ruang kelas, display promosi, CCTV, dan kebutuhan digital kantor.",
    href: "/produk/elektronik",
    image: "/images/electronics/smart-tv-hero.png",
    status: "Lihat detail",
  },
];

export const ProductGateway = () => (
  <section id="produk" data-testid="product-gateway-section" className="editorial-products">
    <div className="editorial-products__line" aria-hidden="true" />
    <div className="editorial-products__shell">
      <div className="editorial-products__intro">
        <div className="editorial-products__intro-sticky">
          <div className="tag-uppercase text-[#e60012] mb-4">Produk &amp; Unit Bisnis</div>
          <h2>Lini produk yang dapat berkembang mengikuti kebutuhan pelanggan</h2>
          <p>
            PT APL menyediakan lini produk untuk kebutuhan material, display, retail, interior,
            dapur komersial, elektronik, dan proyek. Setiap kategori dilengkapi halaman detail agar
            katalog, spesifikasi, dan informasi teknis mudah dipahami.
          </p>
          <div className="editorial-products__count" aria-hidden="true">
            <strong>04</strong><span>Lini Produk</span>
          </div>
        </div>
      </div>

      <div className="editorial-products__showcase">
        {productLines.map((item, index) => (
          <Link
            key={item.title}
            to={item.href}
            onClick={() => trackEvent("click_product_card", {
              category: "product",
              label: item.title,
              product_name: item.analyticsName,
            })}
            className="editorial-product"
          >
            <article data-testid={`product-line-${index}`}>
              <div className="editorial-product__media">
                <img src={item.image} alt={item.title} loading="lazy" decoding="async" />
                <span className="editorial-product__number">0{index + 1}</span>
              </div>
              <div className="editorial-product__content">
                <div>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
                <span className="editorial-product__link">
                  {item.status}<ArrowRight />
                </span>
              </div>
            </article>
          </Link>
        ))}
      </div>
    </div>
  </section>
);
